import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import FlooringMaterials from "@/components/site/FlooringMaterials";
import BeforeAfter from "@/components/site/BeforeAfter";
import Portfolio from "@/components/site/Portfolio";
import VideoShowcase from "@/components/site/VideoShowcase";
import OurStory from "@/components/site/OurStory";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import ServiceAreas from "@/components/site/ServiceAreas";
import CTABand from "@/components/site/CTABand";
import QuoteContact from "@/components/site/QuoteContact";
import Footer from "@/components/site/Footer";
import MobileStickyCTA from "@/components/site/MobileStickyCTA";

export default function Landing() {
  return (
    <div className="min-h-screen bg-stone-50 text-stone-900" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <FlooringMaterials />
        <BeforeAfter />
        <Portfolio />
        <VideoShowcase />
        <OurStory />
        <WhyChooseUs />
        <Process />
        <Testimonials />
        <ServiceAreas />
        <FAQ />
        <CTABand />
        <QuoteContact />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
